var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserpersonaslogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 810 810",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 110.594h648v589.148H81Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.5 110.594h513c37.277 0 67.5 30.222 67.5 67.5v453.812c0 37.278-30.223 67.5-67.5 67.5h-513c-37.277 0-67.5-30.222-67.5-67.5V178.094c0-37.278 30.223-67.5 67.5-67.5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.035 392h363.75v231.672h-363.75Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308 186.422h193V379H308Zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffd154",
    d: "M81 110.594h648v588.515H81Zm0 0"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#274472",
    d: "M476.535 392.887c30.695 1.281 58.067 14.593 78.02 35.328 19.949 20.734 32.23 48.894 32.23 79.867v107.77c0 4.351-3.582 7.68-7.676 7.68H230.707c-4.348 0-7.672-3.329-7.672-7.68v-107.77c0-30.973 12.278-59.133 32.23-79.867 19.954-20.735 47.579-34.305 78.532-35.328v-.254c2.558 0 5.117 1.277 6.394 3.328 7.676 9.984 17.395 18.176 28.395 23.805 11 5.375 23.277 8.449 36.324 8.449 13.043 0 25.324-3.074 36.067-8.45 11.257-5.628 20.976-13.82 28.652-23.804l6.137 4.351-6.137-4.609c1.531-2.047 4.348-3.328 6.906-2.816Zm67.02 46.078c-16.63-17.406-39.137-28.668-64.207-30.719-8.7 10.496-19.442 19.2-31.465 25.344-13.043 6.398-27.625 9.984-42.973 9.984-15.605 0-30.187-3.586-42.976-9.984-12.278-6.145-23.02-14.848-31.461-25.344-25.07 2.05-47.836 13.313-64.207 30.719-17.395 17.922-27.883 42.238-27.883 69.117v100.09h333.054v-100.09c0-26.879-10.746-51.195-27.882-69.117Zm0 0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#274472",
    d: "M404.91 186.563c26.348 0 50.39 10.75 67.785 28.16 17.395 17.406 28.14 41.468 28.14 68.09 0 26.625-10.745 50.43-28.14 67.835-17.394 17.41-41.437 28.16-67.785 28.16-26.605 0-50.648-10.75-68.043-28.16-17.394-17.406-28.14-41.21-28.14-67.836 0-26.62 10.746-50.683 28.14-68.09 17.395-17.41 41.438-28.16 68.043-28.16Zm57.043 39.167c-14.582-14.593-34.789-23.808-57.043-23.808-22.254 0-42.465 9.215-57.043 23.808-14.84 14.59-23.793 34.813-23.793 57.083 0 22.273 8.953 42.496 23.793 57.085 14.578 14.59 34.79 23.551 57.043 23.551 22.254 0 42.461-8.96 57.043-23.55s23.535-34.813 23.535-57.087c0-22.269-8.953-42.492-23.535-57.082Zm0 0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserpersonaslogo);
export default __webpack_public_path__ + "static/media/userpersonaslogo.a1a7427deac2373d7a44d0a73affd1be.svg";
export { ForwardRef as ReactComponent };